import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Grid,
  Container,
} from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { getActiveSubscriptions } from "../../api/subscription";
import { planInfo } from "./plans";

const SubscriptionTable = ({ subscriptions }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {subscriptions.map((subscription) => (
            <React.Fragment key={subscription.id}>
              <TableRow>
                <TableCell>
                  <Typography>Farm Name</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{subscription.farm_name}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography>Plan</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{planInfo[subscription.plan].name}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography>Description</Typography>
                </TableCell>
                <TableCell>
                  <Typography>
                    {planInfo[subscription.plan].description}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography>Start Time</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{subscription.start_time}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography>End Time</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{subscription.end_time}</Typography>
                </TableCell>
              </TableRow>
              {/* 
                // Uncomment if you want to add a button for viewing invoices
              <TableRow>
                <TableCell></TableCell>
                <TableCell>
                  <Button variant="contained">View Invoice</Button>
                </TableCell>
              </TableRow> */}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default function MySubscriptions() {
  const { t } = useTranslation();
  const [subscriptions, setSubscriptions] = useState(null);

  useEffect(() => {
    getActiveSubscriptions().then((response) => {
      setSubscriptions(response);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Active Subscriptions - Farmapp</title>
      </Helmet>
      <CustomAppBar title="Create Program" />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Active Subscriptions")}</CustomTitle>

            {subscriptions === null && (
              <Typography>{t("Loading...")}</Typography>
            )}

            {subscriptions !== null && subscriptions.length > 0 ? (
              <SubscriptionTable subscriptions={subscriptions} />
            ) : (
              <CustomTitle>{t("No Active Subscription")}</CustomTitle>
            )}
          </Grid>
        </div>
      </Container>
    </>
  );
}
